import { IEnvironment } from '@sona/angular-util-environment';

// eslint-disable-next-line @nx/enforce-module-boundaries
import packageJson from '../../../../package.json';

export const environment: IEnvironment = {
    name: 'production',
    production: true,
    version: packageJson.version,
    defaultLanguage: 'de',
    apiUrl: import.meta.env.NG_APP_API_URL ?? 'host.docker.internal:3333/api',
    faviconUrl:
        import.meta.env.NG_APP_FAVICON_URL ?? 'https://favicon.siteboard.io',
    auth: {
        supabaseUrl: import.meta.env.NG_APP_SUPABASE_URL,
        supabaseAnonKey: import.meta.env.NG_APP_SUPABASE_ANON_KEY
    },
    sentry: {
        dsn: import.meta.env.NG_APP_SENTRY_DSN_ANGULAR,
        tracePropagationTargets: (
            import.meta.env.NG_APP_SENTRY_TRACE_PROPAGATION_TARGETS ??
            'localhost'
        ).split(',')
    },
    analytics: {
        googleTagManager: {
            containerId: 'GTM-MB4N42NK',
            auth: '_KWe6NtbzvPkmhY5b5PBKQ',
            preview: 'env-1',
            debug: false
        },
        googleAnalytics: {
            measurementIds: [ 'G-875JXDMEM4' ]
        },
        seline: {
            token: '87c1966b02ae40c'
        }
    },
    legal: {
        terms: {
            version: 3,
            timestamp: new Date('2025-05-05T00:00:00Z')
        }
    },
    vapid: {
        publicKey: import.meta.env.NG_APP_VAPID_PUBLIC_KEY
    },
    payments: {
        pricingTables: {
            de: import.meta.env.NG_APP_STRIPE_PRICING_TABLE_DE_ID,
            en: import.meta.env.NG_APP_STRIPE_PRICING_TABLE_EN_ID
        },
        publishableKey: import.meta.env.NG_APP_STRIPE_PUBLISHABLE_KEY
    },
    featurebase: {
        appId: import.meta.env.NG_APP_FEATUREBASE_APP_ID
    }
};
